import React from 'react';

const SvgTermsIcon = props => (
  <svg
    id="terms_icon_svg__ic_terms"
    width={props.size || 51.804}
    height={props.size || 65.355}
    viewBox="0 0 51.804 65.355"
    data-name="ic_terms"
    fill="#f5f5f5"
    {...props}
  >
    <g id="terms_icon_svg__Grupo_585" data-name="Grupo 585">
      <path
        id="terms_icon_svg__Trazado_598"
        d="M39.1 0H13.616a2.117 2.117 0 00-2.14 2.14v2.982H2.14A2.026 2.026 0 000 7.2v56.016a2.117 2.117 0 002.14 2.14h47.525a2.117 2.117 0 002.14-2.14V7.2a2.117 2.117 0 00-2.14-2.14h-8.429V2.14A2.078 2.078 0 0039.1 0zM15.755 7.2V4.279h21.2v6.678h-21.2zm31.77 2.14v51.736H4.279V9.336h7.262V13.1a2.117 2.117 0 002.14 2.14h25.48A2.117 2.117 0 0041.3 13.1V9.336h6.224zm0 0"
        className="terms_icon_svg__cls-1"
        data-name="Trazado 598"
      />
      <path
        id="terms_icon_svg__Trazado_599"
        d="M46.507 56.8H15.84a2.14 2.14 0 000 4.279h30.667a2.117 2.117 0 002.14-2.14 2.078 2.078 0 00-2.14-2.14zm0 0"
        className="terms_icon_svg__cls-1"
        data-name="Trazado 599"
        transform="translate(-4.817 -19.973)"
      />
      <path
        id="terms_icon_svg__Trazado_600"
        d="M31.206 72.6H15.84a2.14 2.14 0 000 4.279h15.3a2.14 2.14 0 00.065-4.279zm0 0"
        className="terms_icon_svg__cls-1"
        data-name="Trazado 600"
        transform="translate(-4.817 -25.529)"
      />
      <path
        id="terms_icon_svg__Trazado_601"
        d="M13.8 43.04a2.117 2.117 0 002.14 2.14h30.667a2.117 2.117 0 002.14-2.14 2.078 2.078 0 00-2.14-2.14H15.875a2.1 2.1 0 00-2.075 2.14zm0 0"
        className="terms_icon_svg__cls-1"
        data-name="Trazado 601"
        transform="translate(-4.853 -14.382)"
      />
    </g>
  </svg>
);

export default SvgTermsIcon;
